<template>
  <p style="font-size:12px;color:red">
    {{ $t("admin.NoPartcipantToSearch") }}
  </p>
</template>

<script>
export default {};
</script>
